import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const points = [
  "25+ Years of Trusted Excellence",
  "Top 10 in Debt Recovery",
  "One-Stop Solution for Debt Recovery",
  "Robust Infrastructure & Experienced Team",
  "Process-Driven Execution",
  "ISO 9001:2015 Certified"
];

const FutureSelf = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div style={{
      background: 'linear-gradient(180deg, #000b3e 0, #020202 59%)',
      padding: '50px 20px',
      textAlign: 'center',
      fontFamily: 'Outfit, sans-serif'
    }}>
      <h2 style={{
        fontSize: isMobile ? '22px' : '32px',
        fontWeight: '900',
        marginBottom: '40px',
        color: '#fff'
      }}>
        Roadmap to Success
      </h2>

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '30px',
        justifyContent: 'center',
        maxWidth: '1000px',
        margin: '0 auto'
      }}>
        {points.map((text, idx) => (
          <div
            key={idx}
            style={{
              backgroundColor: '#e8fff2',
              border: '1px solid #c8f0d4',
              borderRadius: '12px',
              padding: isMobile ? '10px 15px' : '10px 20px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              flex: '1 1 400px',
              minHeight: '60px',
              transition: 'transform 0.4s ease-in-out',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <FaCheckCircle color="#000" size={20} style={{ flexShrink: 0 }} />
            <span style={{
              textAlign: 'left',
              fontSize: isMobile ? '14px' : '16px',
              fontWeight: 500,
              lineHeight: '1.4'
            }}>
              {text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FutureSelf;
